/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from "react";
import { ErrorBoundary } from "../custom-error/ErrorBoundary";
import { loadComponent } from "./remoteComponentHelper";

const RemoteComponent = (props) => {
  const Component = React.lazy(
    loadComponent(
      props.remote,
      window.location.origin,
      `./${props.component}`,
      props.scope,
      props.buildPath,
      props.fallback
    )
  );
  return (
    <ErrorBoundary>
      <React.Suspense fallback={props.fallback || "Loading..."}>
        <Component {...props}>{props.children}</Component>
      </React.Suspense>
    </ErrorBoundary>
  );
};

export { RemoteComponent };
